import AjaxService from '../services/ajax-service';

import { handleServerError } from 'shared-services/error-service';
import { convertToFormData } from '../utils/helpers';

export const fetchFiles = ({ projectId, userId, taskId, offset = 0, limit = 15 }) => {
    return AjaxService({
        method: 'get',
        url: `files`,
        params: {
            project_id: projectId,
            user_id: userId,
            task_id: taskId,
            offset,
            limit
        }
    })
    .then(response => response.data)
    .catch(handleServerError);
}

export const uploadFiles = (files, { project, task, doc }) => {
    return AjaxService({
        method: 'post',
        url: 'files',
        params: {
            project_id: project,
            task_id: task,
            doc_id: doc
        },
        data: convertToFormData({
            files
        })
    })
    .then(response => response.data.files)
    .catch(handleServerError);
}

export const fetchFile = fileId => {
    return AjaxService({
        method: 'get',
        url: `files/${fileId}`
    })
    .then(response => response.data)
    .catch(handleServerError);
}

export const removeFile = fileId => {
    return AjaxService({
        method: 'delete',
        url: `files/${fileId}`
    })
    .then(response => response.data)
    .catch(handleServerError);
}

export const checkStorageLimit = size => {
    return AjaxService({
        method: 'post',
        url: `teams/file_limits`,
        data: { size }
    })
    .then(response => response.data);
}

export const updateFile = (fileId, { archived }) => {
    return AjaxService({
        method: 'put',
        url: `files/${fileId}`,
        data: {
            archived
        }
    }).then(response => response.data.data);
}

export const copyFile = (fileId, data) => {
    return AjaxService({
        method: 'post',
        url: `files/${fileId}/copy`,
        data
    })
    .then(response => response.data)
    .catch(handleServerError);
}

export const externalLoad = ({ project, task, doc, files }) => {
    return AjaxService({
        method: 'post',
        url: 'files/download',
        data: {
            project_id: project,
            task_id: task,
            doc_id: doc,
            files
        }
    }).then(response => response.data);
}
